<template>
  <div>Loggin you in...</div>
</template>

<script>
export default {
  name: "Redirect",
  created() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop)
    });
    // const storeId = params.storeId;
    // const existingToken = window.localStorage.getItem("authToken");

    // if (existingToken) {
    //   const payload = this.parseJwt(existingToken);
    //   if (payload.storeId === storeId) {
    //     this.$router.push({ name: "Home" });
    //     return;
    //   }
    // }

    const redirectUrl = params.url;
    if (redirectUrl && window.top) {
      const host = new URLSearchParams(location.search).get("host");
      if (host) {
        open(redirectUrl, "_top");
      } else {
        window.top.location = redirectUrl;
      }
    }
  },
  methods: {
    parseJwt(token) {
      var base64Payload = token.split(".")[1];
      var payload = Buffer.from(base64Payload, "base64");
      return JSON.parse(payload.toString());
    }
  }
};
</script>

<style lang="scss" scoped></style>
